import config from '@config';
const store = () => Framework7.createStore({
  state: {
    _APIURI: config.apiUri.v1,
    _FBOAUTH: config.fbOauth,
    _PUSHER: config.pusher,
    _TOKBOX: config.tokbox,
    _STRIPE: config.stripe,
    _LP_URI: config.lpUri,
    _TOKEN: "",
    _SAVING_EVENT: false,
    _USER: {},
    _ORGANIZERS: [],
    _ACTIVE_ORGANIZER: {},
    _ACTIVE_ORGANIZER_EVENTS: [],
    _ACTIVE_ORGANIZER_EVENT_ID: 0,
    _EVENT: {},
    _MESSAGES: [],
    _ACTIVE_CHAT: null,
    _ACTIVE_PRIVATE_CHAT: null,
    _CHAT_REPORTS_COUNT: 0,
    _ADD_PEOPLE_TO_CHAT: false,
    _CHATS: { public: [], private: [] },
    _EVENT_USERS: [],
    _CHOSEN_MESSAGE_ID: 0,
    _PRIVATE_CHAT_MESSAGES: [],
    _PRIVATE_CHAT_PARTICIPANTS: [],
    _USER_CONNECTIONS: [],
    _ACTIVE_QUESTIONS_CHANNEL: null,
    _BLACKLIST: [],
    _INCOGNITO: null,
    _CHAT_REPORTS: [],
    _CHOSEN_USER_ID: null,
    _SELECTED_USER_IDS: [],
    _CHAT_LIST_ACTIVE: false,
  },
  getters: {
    api({ state }) {
      return state._APIURI;
    },
    lpUri({ state }){
      return state._LP_URI;
    },
    stripe({ state }) {
      return state._STRIPE;
    },
    tokbox({ state }) {
      return state._TOKBOX;
    },
    authfb({ state }) {
      return state._FBOAUTH;
    },
    pusher({ state }) {
      return state._PUSHER;
    },
    token({ state }) {
      return state._TOKEN;
    },
    savingEvent({ state }){
      return state._SAVING_EVENT;
    },
    user({ state }) {
      return state._USER;
    },
    organizers({ state }) {
      return state._ORGANIZERS;
    },
    activeOrganizer({state}) {
      return state._ACTIVE_ORGANIZER;
    },
    activeOrganizerEvents({state}){
      return state._ACTIVE_ORGANIZER_EVENTS;
    },
    activeEvent({state}){
      return state._ACTIVE_ORGANIZER_EVENTS.filter(item => item.id == state._ACTIVE_ORGANIZER_EVENT_ID );
    },
    event({state}){
      return state._EVENT;
    },
    userConnections({state}){
      return state._USER_CONNECTIONS;
    },
    activeChat({state}) {
      return state._ACTIVE_CHAT
    },
    addPeople({state}) {
      return state._ADD_PEOPLE_TO_CHAT
    },
    privateChat({state}) {
      return state._ACTIVE_PRIVATE_CHAT
    },
    eventUsers({state}) {
      return state._EVENT_USERS
    },
    chosenMessageId({state}) {
      return state._CHOSEN_MESSAGE_ID
    },
    privateChatMessages({state}) {
      return state._PRIVATE_CHAT_MESSAGES
    },
    privateChatParticipants({state}) {
      return state._PRIVATE_CHAT_PARTICIPANTS
    },
    chats({state}) {
      return state._CHATS
    },
    chatReportsCount({ state }) {
      return state._CHAT_REPORTS_COUNT
    },
    activeQuestionsChannel({ state }) {
      return state._ACTIVE_QUESTIONS_CHANNEL;
    },
    blacklist({state}) {
      return state._BLACKLIST;
    },
    incognito({state}) {
      return state._INCOGNITO;
    },
    chatReports({state}) {
      return state._CHAT_REPORTS;
    },
    chosenUserId({state}) {
      return state._CHOSEN_USER_ID;
    },
    selectedUserIds({state}) {
      return state._SELECTED_USER_IDS;
    },
    chatListActive({state}) {
      return state._CHAT_LIST_ACTIVE;
    },
  },
  actions: {
    addProduct({ state }, product) {
      state.products = [...state.products, product];
    },
    toggleSaving({state}, val) {
      state._SAVING_EVENT = val;
    },
    getEvent({state}, event_id){
      return new Promise((resolve,reject) => {
        app.preloader.show()
        app.request.json(app.store.getters.api.value + "event" + "?id=" + event_id)
        .then(function(res){
          state._EVENT = res.data;
          resolve();
        }).catch(function(err) {
          reject(err.xhr);
        }).finally(()=>app.preloader.hide())
      })
    },
    getEventsByOrganizer({state}, orgID){
      return new Promise((resolve,reject) => {
        app.preloader.show()
        let organizer_id = state._ACTIVE_ORGANIZER.id;
        app.request.json(app.store.getters.api.value + "panel/events" + "?organizer_id=" + organizer_id)
        .then(function(res){
          if(app.params.type==='dev')console.info('%c__ events ___', 'color: #dddd44;');
          let events = res.data;
          state._ACTIVE_ORGANIZER_EVENTS = events;
          resolve();
          return;
        })
        .catch(function(err) {
          reject(err);
          return;
        })
        .finally(()=>app.preloader.hide())
      })
    },
    async getUsersConnections({}, { event_id }) {
      const url = `${app.store.getters.api.value}event/networking/connections`;
      app.preloader.show();
      try {
        const { data: userConnections } = await app.request.getJSON(url, { event_id }).finally(()=>app.preloader.hide())
        app.store.state._USER_CONNECTIONS = userConnections;
        return userConnections;
      } catch (err) {
        return err;
      }
    },
    getOrganizers({ state }, link) {
      return new Promise((resolve,reject) => {
        if (link){localStorage.setItem("o",link)}
        app.preloader.show()
        app.request.json(app.store.getters.api.value + "panel/organizers")
          .then(function(res) {
            if(app.params.type==='dev')console.info('%c__ organizers ___', 'color: #dddd44;');
            let organizers = res.data;
            app.store.state._ORGANIZERS = organizers;
            if (!localStorage.getItem("o") && organizers.length) {
              localStorage.setItem("o", organizers[0].link);
              app.store.state._ACTIVE_ORGANIZER = organizers[0];
              app.emit('activeOrganizerUpdated');
              resolve();
              return;
            } else if (localStorage.getItem("o") && !organizers.length) {
              localStorage.removeItem("o");
              app.views.main.router.navigate("/not-found/");
            } else if (localStorage.getItem("o") && organizers.length) {
              app.store.state._ACTIVE_ORGANIZER = organizers.find(o => o.link ==localStorage.getItem("o" ));
              if(app.store.state._ACTIVE_ORGANIZER===undefined){
                localStorage.setItem("o", organizers[0].link);
                app.store.state._ACTIVE_ORGANIZER = organizers[0];
              }
              app.emit('activeOrganizerUpdated');
              resolve();
            } else {
              localStorage.removeItem("o");
              resolve();
            }
          })
          .catch(function(err) {
            if(err.xhr.status==401)reject();
          })
          .finally(()=>app.preloader.hide())
      });
    },
    setActiveChat({state}, chatData) {
      state._ACTIVE_CHAT = chatData;
    },
    setActivePrivateChat({state}, chatId) {
      state._ACTIVE_PRIVATE_CHAT = chatId
      let chat = state._CHATS.private.find((el) => el.channel == chatId)
      if (chatId && chat.unreadMessages) {
        delete chat.unreadMessages;
      }
    },
    setAddPeople({state}, open) {
      state._ADD_PEOPLE_TO_CHAT = open
    },
    setEventUsers({ state }, users) {
      state._EVENT_USERS = users.filter((el) => el.first_name != null);
    },
    setChosenMessageId({state}, id) {
      state._CHOSEN_MESSAGE_ID = id;
    },
    addPrivateChatParticipant({state}, data) {
      let chat = state._CHATS.private.find((el) => el.channel == data.channel)
      let participant = state._EVENT_USERS.filter((user) => user.id == data.participantId).email
      chat.participants = [...chat.participants, participant]
    },
    addPrivateChatParticipants({state}, data) {
      let chat = state._CHATS.private.find((el) => el.channel == data.channel)
      let participants = state._EVENT_USERS.filter((user) => data.participantsIds.includes(user.id)).map((user) => user.email)
      chat.participants = [...new Set([...chat.participants, ...participants])]
    },
    setPrivateChatParticipants({state}, participants) {
      state._PRIVATE_CHAT_PARTICIPANTS = participants
    },
    blockEventUser({state}, userId) {
      let user = state._EVENT_USERS.find((el) => el.id == userId);
      user.chat_blocked = 1
    },
    unblockEventUser({state}, userId) {
      let user = state._EVENT_USERS.find((el) => el.id == userId);
      user.chat_blocked = 0
    },
    setPublicChat({state}, chatData) {
      if (!state._CHATS.public.map(el => el.channel).includes(chatData.channel)) {
        state._CHATS.public.push(chatData)
      }
    },
    setPrivateChats({state}, chats) {
      let fetchedChats = chats;
      fetchedChats.forEach(chat => { chat.messages = [];  chat.messageFetched = false})
      if (chats) {
        state._CHATS.private = fetchedChats;
      }
    },
    setPrivateChat({state}, chatData) {
      if (!state._CHATS.private.map(el => el.channel).includes(chatData.channel)) {
        state._CHATS.private = [...state._CHATS.private, {...chatData, messages: chatData.messages ? chatData.messages : []}]
      }
    },
    deletePrivateChat({state}, data) {
      state._CHATS.private = state._CHATS.private.filter((chat) => chat.channel != data.channel);
    },
    setPrivateChatMessages({state}, data) {
      let chat = state._CHATS.private.find((el) => el.channel == data.id)
      chat.messageFetched = true;
      chat.messages = [...new Set(data.messages)]
    },
    setPrivateChatMessage({state}, data) {
      if (data.leaveChat == true) {
        let chat = state._CHATS.private.find((el) => el.channel == data.channel)
        chat.messages = [...chat.messages, data]
        chat.last_message = {...data, created_at: data.message.created_at}
      } else {
        let channel = JSON.parse(data.message).channel
        let chat = state._CHATS.private.find((el) => el.channel == channel)
        chat.last_message = {...data, created_at: JSON.parse(data.message).created_at}
        if (!chat.messages.map((message) => message.id).includes(data.id) && chat.messageFetched) {
          chat.messages.push({ id: data.id, message: data.message})
        }
        if (state._ACTIVE_PRIVATE_CHAT != channel) {
          chat.unreadMessages = true;
        }
      }
    },
    removePrivateChatParticipant({state}, data) {
      let chat = state._CHATS.private.find((el) => el.channel == data.channel)
      chat.participants = chat.participants.filter((participant) => participant != data.email)
    },
    setPublicChatMessages({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      chat.messages = [...(new Set([...chat.messages, ...data.messages]))]
    },
    setPublicChatMessage({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      if (!chat.messages.map((message) => message.id).includes(data)) {
        chat.messages = [...(new Set([ ...chat.messages, data.message]))]
      }
    },
    setPublicChatQuestions({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      chat.questions = [...chat.questions, ...data.questions]
    },
    setPublicChatQuestion({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      chat.questions = [...chat.questions, data.question]
    },
    deleteMessage({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      let msgIndex = chat.messages.findIndex((msg) => msg.id == data.id)
      chat.messages.splice(msgIndex, 1)
    },
    getPublicChatMessage({state}, {channel, messageId}) {
      var chat = state._CHATS.public.find((chat) => chat.channel == channel)
      return chat.messages.find((message) => message.id == messageId)
    },
    deletePrivateMessage({state}, data) {
      let chat = state._CHATS.private.find((el) => el.channel == data.channel)
      let msgIndex = chat.messages.findIndex((msg) => msg.id == data.id)
      chat.messages.splice(msgIndex, 1)
    },
    deleteQuestion({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      chat.questions = chat.questions.filter((question) => question.id != data.id)
    },
    downvoteQuestion({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      let question = chat.questions.find((el) => el.id == data.id)
      question.reactions = question.reactions.filter((reaction) => reaction.reacting_email != data.email)
    },
    upvoteQuestion({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      let question = chat.questions.find((el) => el.id == data.id)
      question.reactions.push(data.reaction)
    },
    setQuestionAnswered({state}, data) {
      let chat = state._CHATS.public.find((el) => el.channel == data.channel)
      chat.questions.find((q) => q.id == data.id).answered = 1
    },
    updateChatReportsCount({ state }, { count }) {
      state._CHAT_REPORTS_COUNT = count;
    },
    addEventUser({state}, data) {
      state._EVENT_USERS = [...state._EVENT_USERS, data]
    },
    deleteEventUser({state}, id) {
      state._EVENT_USERS = state._EVENT_USERS.filter((el) => el.id != id)
    },
    setActiveQuestionsChannel({state}, data) {
      state._ACTIVE_QUESTIONS_CHANNEL = data;
    },
    setBlacklist({state}, data) {
      state._BLACKLIST = data;
    },
    addUserToBlacklist({state}, userId) {
      state._BLACKLIST.blacklist = [...state._BLACKLIST.blacklist, { user_id: userId }]
    },
    removeUserFromBlacklist({state}, userId) {
      state._BLACKLIST.blacklist = state._BLACKLIST.blacklist.filter((el) => el.user_id != userId)
    },
    addUserToBlacklistedMe({state}, userId) {
      state._BLACKLIST.blacklistedMe = [...state._BLACKLIST.blacklistedMe, { user_id: userId }]
    },
    removeUserFromBlacklistedMe({state}, userId) {
      state._BLACKLIST.blacklistedMe = state._BLACKLIST.blacklistedMe.filter((el) => el.user_id != userId)
    },
    toggleIncognito({state}) {
      state._INCOGNITO = !state._INCOGNITO;
    },
    blockUser({state}) {
      state._EVENT.access.participant.chat_blocked = 1;
    },
    unblockUser({state}) {
      state._EVENT.access.participant.chat_blocked = 0;
    },
    togglePinMessage({state}, data) {
      var chat = state._CHATS.public.find((el) => el.channel == data.channel)
      var message = chat.messages.find((msg) => msg.id == data.id)
      message.is_pinned = !message.is_pinned
    },
    setChatReports({state}, data) {
      state._CHAT_REPORTS = data;
    },
    addChatReport({state}, data) {
      if (!state._CHAT_REPORTS.find((report) => report.id == data.id)) {
        state._CHAT_REPORTS = [...state._CHAT_REPORTS, data]
      }
    },
    removeChatReport({state}, data) {
      state._CHAT_REPORTS = state._CHAT_REPORTS.filter((report) => report.id != data.id);
    },
    setChosenUserId({state}, userId) {
      state._CHOSEN_USER_ID = userId;
    },
    toggleSelectUser({state}, userId) {
      if (state._SELECTED_USER_IDS.includes(userId)) {
        state._SELECTED_USER_IDS = state._SELECTED_USER_IDS.filter((id) => id != userId);
      } else {
        state._SELECTED_USER_IDS.push(userId);
      }
    },
    clearSelectedUsers({state}) {
      state._SELECTED_USER_IDS = [];
    },
    setSelectedUserIds({state}, userIds) {
      state._SELECTED_USER_IDS = userIds;
    },
    renamePrivateChat({state}, data) {
      var chat = state._CHATS.private.find((el) => el.channel == data.tmpName)
      chat.channel = data.newName;
    },
    setChatListActive({state}, active) {
      state._CHAT_LIST_ACTIVE = active;
    }
  },
});

export default store;
